import { axiosPrivate, axiosPublic } from '../services/axios'

export default function useAxios() {
    return { axiosPrivate, axiosPublic }
}